import runes from "@-/com.npmjs.runes2";
import arrayLength from "@-/com.npmjs.extra-array__length";
import type { SentenceWord } from "@-/dev.improve.haniverse.lib.sentence.words";
import type { SentenceDrillToken } from "@-/dev.improve.haniverse.lib.sentence.drill";

/**
 * Turn `useSentenceWords` output into drill tokens by attaching each one's char offset.
 *
 * The offsets are ACCUMULATED from the segment lengths rather than re-derived with jieba's
 * `tokenize()`. `useSentenceWords` already returns the segments in reading order and covering the
 * whole sentence, so running a second segmentation pass would be both redundant and a chance for
 * the two passes to disagree — at which point an offset would point at the wrong characters.
 *
 * Counted in code points (`runes`) rather than UTF-16 units so a sentence containing a
 * supplementary-plane character does not shift every offset after it.
 */
export function toSentenceDrillTokens(
  words: readonly SentenceWord[],
): readonly SentenceDrillToken[] {
  const tokens: SentenceDrillToken[] = [];
  let charOffset = 0;
  for (const { pinyin, word } of words) {
    tokens.push({ charOffset, pinyin, word });
    charOffset += arrayLength(runes(word));
  }
  return tokens;
}
